// Mock reviews data for the Caribbean LGBTQ+ travel platform
const mockReviews = [
  {
    id: 1,
    title: "Welcoming Beachfront Resort",
    author: {
      id: 1,
      name: "Maria Sanchez",
      avatar: "https://randomuser.me/api/portraits/women/65.jpg"
    },
    date: "2025-05-15",
    location: "San Juan, Puerto Rico",
    venueName: "La Concha Resort",
    venueType: "accommodation",
    rating: 4.5,
    content: "La Concha Resort in San Juan is openly LGBTQ+ friendly. The staff was welcoming to me and my girlfriend, and we never felt uncomfortable. The beachfront location is perfect, and they even had a Pride event during our stay!",
    images: [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/210469027.jpg?k=1e1c8c6a3cba9a16b32c9248aacc0ed3b2a3524459ac867d4e5f59fe1b6a05e7&o=&hp=1"
    ],
    tags: ["lgbtq-friendly", "beachfront", "luxury", "couples"],
    safetyRating: 5,
    inclusivityRating: 5,
    likes: 32,
    helpful: 18,
    visibility: "public"
  },
  {
    id: 2,
    title: "Amazing Diving Experience",
    author: {
      id: 3,
      name: "Sophie Williams",
      avatar: "https://randomuser.me/api/portraits/women/33.jpg"
    },
    date: "2025-04-10",
    location: "Kralendijk, Bonaire",
    venueName: "Buddy Dive Resort",
    venueType: "activity",
    rating: 5,
    content: "As a non-binary person, I was a bit nervous about joining a group diving excursion, but Buddy Dive was incredibly inclusive. They respected my pronouns and made sure I felt comfortable throughout the experience. The reef diving was spectacular!",
    images: [
      "https://www.buddydive.com/wp-content/uploads/2019/10/Buddy_Dive_Resort_Bonaire_Dive_Operation_Dock_Boats.jpg"
    ],
    tags: ["diving", "inclusive", "non-binary friendly", "adventure"],
    safetyRating: 5,
    inclusivityRating: 5,
    likes: 24,
    helpful: 15,
    visibility: "community"
  },
  {
    id: 3,
    title: "Hidden Gem Restaurant",
    author: {
      id: 7,
      name: "Elena Rodriguez",
      avatar: "https://randomuser.me/api/portraits/women/28.jpg"
    },
    date: "2025-03-25",
    location: "Havana, Cuba",
    venueName: "La Guarida",
    venueType: "dining",
    rating: 4,
    content: "La Guarida is not only one of the best restaurants in Havana, but it's also very LGBTQ+ friendly. The staff was welcoming and the atmosphere is romantic and inclusive. Perfect for a date night! The rooftop bar has amazing views of the city.",
    images: [
      "https://media-cdn.tripadvisor.com/media/photo-s/16/c5/82/9c/at-la-guarida.jpg"
    ],
    tags: ["restaurant", "romantic", "lgbtq-friendly", "cuban cuisine"],
    safetyRating: 4,
    inclusivityRating: 5,
    likes: 19,
    helpful: 12,
    visibility: "public"
  },
  {
    id: 4,
    title: "Disappointing Beach Club Experience",
    author: {
      id: 6,
      name: "Marcus Johnson",
      avatar: "https://randomuser.me/api/portraits/men/55.jpg"
    },
    date: "2025-06-02",
    location: "Montego Bay, Jamaica",
    venueName: "Sunset Beach Club",
    venueType: "nightlife",
    rating: 2,
    content: "While the venue itself is beautiful, I experienced some uncomfortable moments as a trans man. The security staff was particularly unwelcoming and questioned my ID multiple times. The management needs better training on LGBTQ+ inclusivity.",
    images: [],
    tags: ["beach club", "not inclusive", "safety concerns"],
    safetyRating: 2,
    inclusivityRating: 1,
    likes: 27,
    helpful: 22,
    visibility: "community"
  },
  {
    id: 5,
    title: "Perfect Wedding Venue",
    author: {
      id: 9,
      name: "Olivia Smith",
      avatar: "https://randomuser.me/api/portraits/women/17.jpg"
    },
    date: "2025-05-20",
    location: "Nassau, Bahamas",
    venueName: "Atlantis Paradise Island",
    venueType: "accommodation",
    rating: 5,
    content: "We had our wedding at Atlantis and it was absolutely perfect! The resort is fully supportive of LGBTQ+ weddings and went above and beyond to make our ceremony special. The staff was professional and treated us just like any other couple.",
    images: [
      "https://www.atlantisbahamas.com/media/Things%20To%20Do/Water%20Park/Beaches/Paradise%20Beach/T2D_WaterPark_Beaches_ParadiseBeach_Beach_1.jpg"
    ],
    tags: ["wedding venue", "lgbtq-friendly", "luxury", "inclusive"],
    safetyRating: 5,
    inclusivityRating: 5,
    likes: 45,
    helpful: 30,
    visibility: "public"
  }
];

export default mockReviews;
